import { render } from "./AnimatedInput.vue?vue&type=template&id=777aa166&scoped=true&ts=true"
import script from "./AnimatedInput.vue?vue&type=script&lang=ts"
export * from "./AnimatedInput.vue?vue&type=script&lang=ts"

import "./AnimatedInput.vue?vue&type=style&index=0&id=777aa166&scoped=true&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777aa166"]])

export default __exports__